import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { SafeHtmlPipe } from '../../pipes/safe-html-pipe';
import { APP_ICONS } from './app-icon.registry';

@Component({
  selector: 'app-icon',
  imports: [NgClass, SafeHtmlPipe],
  templateUrl: './app-icon.component.html',
  styleUrl: './app-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AppIconComponent {
  public name = input<string | null>(null);
  public svg = input<string | null>(null);
  public size = input<number | string | null>(null);
  public ariaLabel = input<string | null>(null);
  public iconClass = input<string | null>(null);

  protected readonly svgMarkup = computed(() => {
    const customSvg = this.svg();

    if (customSvg) {
      return customSvg;
    }

    const iconName = this.name();

    if (!iconName) {
      return null;
    }

    return APP_ICONS[iconName] ?? null;
  });

  protected readonly sizeValue = computed(() => {
    const size = this.size();

    if (size === null || size === undefined || size === '') {
      return null;
    }

    return typeof size === 'number' ? `${size}px` : size;
  });

  protected readonly ariaHidden = computed(() =>
    this.ariaLabel() ? null : 'true',
  );
}
